<template>
  <div class="pinned-user-available">
    <UserIcon
      class="user-icon"
			:userId="user.pinnedUserId"
			:userStatus="user.status"
		/>

    <div class="name">
      <span class="name__fullname">{{user.firstName}} {{user.lastName}}</span>
      <span v-if="user.pronouns && user.pronouns != ''" class="name__pronouns">({{user.pronouns}})</span>
    </div>

    <newTimesince class="time" :timestamp="`${data.timestamp.indexOf('Z') === -1 ? `${data.timestamp}Z` : data.timestamp }`"/>

    <div class="status">
      is available
    </div>

    <footer class="buttons">
      <IconButton
        :icon="require(`@/assets/global-icons/cross-white.svg`)"
        @onClick="cancel"
        colour="ghost"
        label="Cancel pin"
      />

      <IconButton
        :icon="require(`@/assets/notification-icons/camcorder-white.svg`)"
        @onClick="invite"
        colour="green"
        iconSize="32px"
        label="Invite to a Room"
      />
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import newTimesince from '@/components/sidebar/newTimesince.vue';
import { IconButton } from '@/framework';
import UserIcon from '@/components/UserIcon.vue'

export default {
  name: 'PinnedUserAvailable',
  components: {
    UserIcon,
    IconButton,
    newTimesince
  },
  props: {
    notificationId: String
  },
  computed: {
    ... mapGetters(['getCurrentNotification']),
    data() {
      const current = this.getCurrentNotification

      if (current.id == this.notificationId) {
        return current
      } else {
        return undefined
      }
    },

    user() {
      return this.data.data
    }
  },
  created() {
    this.$emit('modalSettings', {
        styles: {
          'min-width': "350px",
          'max-width': "350px"
        },
        fullScreenOnMobile: false,
        hasCloseButton: false
    })
  },
  methods: {
    ... mapActions(['modal/close', 'invitePinnedUserHandler', 'clearCurrentNotification', 'cancelPinHandler']),
    cancel() {
      this['modal/close']()
      this.cancelPinHandler([this.user.pinsId])
    },
    async invite() {
      this['modal/close']()
      this.invitePinnedUserHandler(this.data)
    }
  },
  beforeDestroy() {
    if (this.getCurrentNotification.id == this.notificationId) {
      this.clearCurrentNotification()
    }
  }
}
</script>
<style scoped lang="scss">
.user-icon {
  width: 80px;
  height: 80px;
}

.pinned-user-available {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.name {
  &__fullname {
    font-size: 1.125rem;  /** 18px */
    color: white;
    font-weight: bold;
    margin-right: 8px;
    vertical-align: middle;
  }

  &__pronouns {
    color: $grey-1;
    font-size: 1rem;
    vertical-align: middle;
  }
}

.time {
  font-size: 0.875rem; /** 14px */
  font-weight: bold;
  color: $grey-1;
}

.status {
  font-weight: bold;
  font-size: 1.5rem; /** 24px */
  color: $active-user-room;
}

.buttons {
  margin-top: 20px;
  width: 50%;
  display: flex;
  justify-content: space-around;
  min-width: 239px;
}
</style>
